import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  CONTROL_PANEL_ACTION_AGENT,
  CONTROL_PANEL_AGENT_STATISTICS,
  CONTROL_PANEL_GENERAL_INVESTMENT,
  CONTROL_PANEL_INVEST_DETAIL_OPERATION,
  CONTROL_PANEL_INVEST_PRODUCT,
  CONTROL_PANEL_OPERATION_DETAIL,
  CONTROL_PANEL_OPERATION_VALIDATION,
  CONTROL_PANEL_PENALTY_DETAIL_OPERATION,
} from '@app/@core/constants/routes.constants';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ControlPanelGuard } from './control-panel.guard';

const routes: Routes = [
  {
    path: CONTROL_PANEL_INVEST_DETAIL_OPERATION,
    loadChildren: () => import('./invest-detail/invest-detail.module').then((m) => m.InvestDetailModule),
    data: { title: marker('sidenav.menu.controlPanel.investDetail') },
    canActivate: [ControlPanelGuard],
  },
  {
    path: CONTROL_PANEL_PENALTY_DETAIL_OPERATION,
    loadChildren: () => import('./penalty-detail/penalty-detail.module').then((m) => m.PenaltyDetailModule),
    data: { title: marker('sidenav.menu.controlPanel.penalty.detail') },
    canActivate: [ControlPanelGuard],
  },
  {
    path: CONTROL_PANEL_INVEST_PRODUCT,
    loadChildren: () => import('./invest-product/invest-product.module').then((m) => m.InvestProductModule),
    data: { title: marker('sidenav.menu.controlPanel.investProduct') },
    canActivate: [ControlPanelGuard],
  },
  {
    path: CONTROL_PANEL_OPERATION_DETAIL,
    loadChildren: () => import('./operation-detail/operation-detail.module').then((m) => m.OperationDetailModule),
    data: { title: marker('sidenav.menu.controlPanel.operationDetail') },
    canActivate: [ControlPanelGuard],
  },
  {
    path: CONTROL_PANEL_AGENT_STATISTICS,
    loadChildren: () => import('./agent-statistics/agent-statistics.module').then((m) => m.AgentStaticticsModule),
    data: { title: marker('sidenav.menu.controlPanel.agentStatistics') },
    canActivate: [ControlPanelGuard],
  },
  {
    path: CONTROL_PANEL_ACTION_AGENT,
    loadChildren: () => import('./action-agent/action-agent.module').then((m) => m.ActionAgentModule),
    data: { title: marker('sidenav.menu.controlPanel.actionAgent') },
    canActivate: [ControlPanelGuard],
  },
  {
    path: CONTROL_PANEL_OPERATION_VALIDATION,
    loadChildren: () =>
      import('./operation-validation/operation-validation.module').then((m) => m.OperationValidationModule),
    data: { title: marker('sidenav.menu.controlPanel.operationValidation') },
    canActivate: [ControlPanelGuard],
  },
  {
    path: CONTROL_PANEL_GENERAL_INVESTMENT,
    loadChildren: () =>
      import('./general-of-investment/general-of-investment.module').then((m) => m.GeneralOfInvestmentModule),
    data: { title: marker('sidenav.menu.controlPanel.generalOfInvestment') },
    canActivate: [ControlPanelGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ControlPanelRoutingModule {}
